/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1735b41a"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__